import { ButtonNew } from '@lune-fe/lune-ui-lib'
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import EmptyStatePlaceholder from 'components/EmptyStatePlaceholder'
import WhiteBoxContainer from 'components/WhiteBoxContainer'
import ClientAccountsIllustration from 'images/client-accounts.png'

const EmptyOrdersSection: FC = () => {
    const navigate = useNavigate()

    return (
        <WhiteBoxContainer
            sx={{
                p: 3,
                mb: 3 / 2,
            }}
        >
            <EmptyStatePlaceholder
                illustration={ClientAccountsIllustration}
                title={'No orders to display'}
                description={`You don't have any orders for the selected time period.`}
                extra={
                    <ButtonNew
                        leadingIcon={<PublicOutlinedIcon />}
                        onClick={() => navigate('/order')}
                    >
                        Fund Climate Projects
                    </ButtonNew>
                }
            />
        </WhiteBoxContainer>
    )
}

export default EmptyOrdersSection
